<!-- Loading bar -->
<devstroupe-loading-bar></devstroupe-loading-bar>

<!-- Navigation (sistema normal) -->
<devstroupe-vertical-navigation
    *ngIf="!isAdminRoute && !isAllocationEngineRoute"
    class="print:hidden"
    [ngClass]="config.class"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigationData"
    [opened]="!isScreenSmall"
    [position]="isRtl ? 'right' : 'left'"
>
    <!-- Navigation header hook -->
    <ng-container devstroupeVerticalNavigationContentHeader>
        <div *ngIf="isRequesterContext" class="flex justify-center items-center px-6 pt-6 pb-1 mt-2">
            <img class="h-6 w-auto dark:hidden" [src]="config.logo" alt="PREHOX" />
            <img class="h-6 w-auto hidden dark:block" [src]="config.logoDark" alt="PREHOX" />
        </div>
        <ng-container *ngIf="!isRequesterContext">
            <ng-container *ngIf="currentCompany$ | async as company; else defaultLogo">
                <div class="flex justify-center items-center h-20 p-6 pb-0 mt-4 mb-4">
                    <img
                        *ngIf="company?.logo; else companyNameFallback"
                        class="w-30 mb-5 max-h-16 object-contain"
                        [src]="company.logo"
                        [alt]="company?.name || 'Logo'"
                    />
                    <ng-template #companyNameFallback>
                        <img class="dark:hidden w-30 mb-5 max-h-16 object-contain" [src]="config.logo" alt="Logo image" />
                        <img class="hidden dark:flex w-30 mb-5 max-h-16 object-contain" [src]="config.logoDark" alt="Logo image" />
                    </ng-template>
                </div>
            </ng-container>
            <ng-template #defaultLogo>
                <div class="flex justify-center items-center h-20 p-6 pb-0">
                    <img class="dark:hidden w-30 mb-5" [src]="config.logo" alt="Logo image" />
                    <img class="hidden dark:flex w-30 mb-5" [src]="config.logoDark" alt="Logo image" />
                </div>
            </ng-template>
        </ng-container>
    </ng-container>
    <!-- Navigation body hook -->
    <ng-container devstroupeVerticalNavigationContentBody>
        <company-selector
            *ngIf="!isAdminRoute && !isAllocationEngineRoute"
            [requesterMode]="isRequesterContext"
        ></company-selector>
    </ng-container>

    <ng-container devstroupeVerticalNavigationFooter>
        <div class="relative flex flex-col flex-0 items-center justify-center w-full py-4 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
            <img *ngIf="!isRequesterContext" class="h-6 w-auto" src="assets/images/logo/prehox-logo.png" alt="PREHOX" />
            <div class="flex items-center gap-2">
                <span class="text-sm text-secondary">&copy; {{ currentYear }}</span>
                <!-- version_app -->
                <span class="text-sm text-secondary" *ngIf="version_app">v{{ version_app }}</span>
            </div>
        </div>
    </ng-container>
</devstroupe-vertical-navigation>

<!-- Wrapper -->
<div
    class="flex flex-col flex-auto w-full min-w-0"
    [ngClass]="isRequesterContext ? 'min-h-0 overflow-hidden' : ''"
>
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full sm:h-16 z-49 print:hidden"
        [ngClass]="isAdminRoute
            ? 'classic-layout-admin-header bg-card dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 shadow-sm'
            : 'px-2 bg-default dark:bg-transparent'"
    >
        <button *ngIf="!isAdminRoute && !isAllocationEngineRoute" mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>

        <!-- Painel Admin: logo -->
        <ng-container *ngIf="isAdminRoute">
            <div class="flex items-center gap-3 shrink-0">
                <!-- Menu hambúrguer: só em telas pequenas, abre os grupos de navegação -->
                <button
                    class="sm:hidden"
                    mat-icon-button
                    [matMenuTriggerFor]="adminMobileMenu"
                    [attr.aria-label]="'Abrir menu' | autoTranslate"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
                <mat-menu #adminMobileMenu="matMenu">
                    <ng-container *ngFor="let group of navigationData">
                        <ng-container *ngIf="group.type === 'collapsable' && group.children?.length">
                            <div class="px-4 pt-2 pb-1 text-xs font-semibold uppercase tracking-wide text-secondary">
                                {{ group.title | autoTranslate }}
                            </div>
                            <a
                                mat-menu-item
                                *ngFor="let child of group.children"
                                [routerLink]="child.link"
                            >
                                <mat-icon *ngIf="child.icon" class="icon-size-4" [svgIcon]="child.icon"></mat-icon>
                                <span>{{ child.title | autoTranslate }}</span>
                            </a>
                        </ng-container>

                        <a
                            *ngIf="group.type === 'basic'"
                            mat-menu-item
                            [routerLink]="group.link"
                        >
                            <span>{{ group.title | autoTranslate }}</span>
                        </a>
                    </ng-container>
                </mat-menu>

                <img class="w-10" src="assets/images/logo/icon.png" alt="Logo image" />
                <span class="hidden sm:inline text-sm font-semibold uppercase tracking-wide text-secondary ms-1" autoTranslate>Painel Admin</span>
            </div>

            <!-- Menus de navegação: centralizados no header (telas médias em diante) -->
            <div class="hidden sm:flex flex-1 items-center justify-center gap-1 min-w-0">
                <ng-container *ngFor="let group of navigationData">
                    <ng-container *ngIf="group.type === 'collapsable' && group.children?.length">
                        <button
                            class="flex items-center gap-1 text-base font-medium text-secondary hover:text-primary hover:bg-hover transition-colors px-2.5 py-1.5 rounded"
                            [matMenuTriggerFor]="adminMenu"
                        >
                            <span>{{ group.title | autoTranslate }}</span>
                            <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:chevron-down'"></mat-icon>
                        </button>
                        <mat-menu #adminMenu="matMenu">
                            <a
                                mat-menu-item
                                *ngFor="let child of group.children"
                                [routerLink]="child.link"
                            >
                                <mat-icon *ngIf="child.icon" class="icon-size-4" [svgIcon]="child.icon"></mat-icon>
                                <span>{{ child.title | autoTranslate }}</span>
                            </a>
                        </mat-menu>
                    </ng-container>

                    <a
                        *ngIf="group.type === 'basic'"
                        [routerLink]="group.link"
                        class="flex items-center gap-1 text-base font-medium text-secondary hover:text-primary hover:bg-hover transition-colors px-2.5 py-1.5 rounded"
                    >
                        <span>{{ group.title | autoTranslate }}</span>
                    </a>
                </ng-container>
            </div>
        </ng-container>

        <app-cockpit-vehicle-header *ngIf="!isAdminRoute && !isAllocationEngineRoute && !isRequesterContext"></app-cockpit-vehicle-header>
        <div
            *ngIf="!isAdminRoute && !isAllocationEngineRoute"
            class="flex min-w-0 flex-1 sm:items-center content-center pe-2 justify-center xl:justify-between xs:flex-wrap gap-2 p-2 sm:p-0"
        >
            <h1 *ngIf="!!pageTitle && !isCockpitRoute" class="text-2xl text-primary font-semibold w-full md:w-auto sm:ms-2 xl:me-20">{{ pageTitle | autoTranslate }}</h1>
            <mat-form-field
                class="devstroupe-mat-dense min-w-60 search-input mx-auto"
                [subscriptSizing]="'dynamic'"
                *ngIf="!isRequesterContext && !(ignoreSearchMobile && isScreenSmall) && showSearch"
            >
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                <input matInput [formControl]="searchInputControl" [autocomplete]="'off'" [placeholder]="'O que você procura?' | autoTranslate" autoTranslate />
                <!-- <input matInput [formControl]="searchInputControl" [autocomplete]="'off'" [placeholder]="'Pesquisar...'"> -->
            </mat-form-field>
        </div>

        <!-- Components -->
        <div class="flex items-center ps-2 pe-2 sm:pe-4 ms-auto gap-0.5 sm:gap-2">
            <!-- Relógio: em Admin/Motor vira dropdown de empresa (fuso); fora, só leitura -->
            <ng-container *ngIf="showClockCompanyPicker; else clockReadOnly">
                <button
                    type="button"
                    class="hidden sm:flex items-center me-1 gap-1.5 rounded-md px-1.5 py-0.5 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                    [matMenuTriggerFor]="clockCompanyMenu"
                    [matTooltip]="'Fuso Horário Operacional' | autoTranslate"
                >
                    <mat-icon class="icon-size-4 flex-shrink-0 text-gray-500 dark:text-gray-400" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                    <div class="flex flex-col items-start leading-tight gap-0.5">
                        <span dir="ltr" class="font-semibold text-sm tabular-nums text-gray-700 dark:text-gray-200">{{ clockText }}</span>
                        <span
                            *ngIf="timezone$ | async as tz"
                            class="text-[9px] font-semibold text-gray-500 dark:text-gray-400 select-none inline-flex items-center gap-0.5"
                        >
                            {{ tz }}
                            <mat-icon class="icon-size-2.5 text-gray-400" [svgIcon]="'heroicons_outline:chevron-down'"></mat-icon>
                        </span>
                    </div>
                </button>
                <mat-menu #clockCompanyMenu="matMenu" panelClass="clock-company-menu-panel">
                    <button
                        mat-menu-item
                        *ngFor="let company of clockCompanies"
                        (click)="selectClockCompany(company)"
                        [ngClass]="{ 'bg-gray-100 dark:bg-gray-800': isClockCompanyActive(company) }"
                    >
                        <span class="flex flex-col items-start leading-tight py-0.5">
                            <span class="text-sm font-medium">{{ company.name }}</span>
                            <span class="text-[10px] text-gray-500 dark:text-gray-400">{{ friendlyTimezoneFor(company) }}</span>
                        </span>
                    </button>
                </mat-menu>
            </ng-container>
            <ng-template #clockReadOnly>
                <div
                    class="hidden sm:flex items-center me-1 gap-1.5"
                    [matTooltip]="'Fuso Horário Operacional' | autoTranslate"
                >
                    <mat-icon class="icon-size-4 flex-shrink-0 text-gray-500 dark:text-gray-400" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                    <div class="flex flex-col items-start leading-tight gap-0.5">
                        <span dir="ltr" class="font-semibold text-sm tabular-nums text-gray-700 dark:text-gray-200">{{ clockText }}</span>
                        <span
                            *ngIf="timezone$ | async as tz"
                            class="text-[9px] font-semibold text-gray-500 dark:text-gray-400 select-none"
                            >{{ tz }}</span
                        >
                    </div>
                </div>
            </ng-template>
            <app-language-selector></app-language-selector>
            <!-- <devstroupe-fullscreen class="hidden md:block"></devstroupe-fullscreen> -->
            <access-approval-bell *ngIf="user?.is_regulator"></access-approval-bell>
            <button
                mat-icon-button
                [matTooltip]="themeToggleTooltip | autoTranslate"
                (click)="cycleTheme()"
            >
                <mat-icon class="icon-size-5" [svgIcon]="themeToggleIcon"></mat-icon>
            </button>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div
        class="flex flex-col flex-auto min-h-0"
        [ngClass]="{
            'classic-layout-admin-content': isAdminRoute,
            'req-screen': isRequesterContext,
            'overflow-hidden': !isRequesterContext,
            'overflow-y-auto': isRequesterContext
        }"
    >
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div class="relative flex flex-0 items-center justify-center w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Trevo &copy; desde 06/2024 </span>
    </div> -->
</div>
